import React, { useEffect } from 'react';
import { ThemeContextProvider, useTheme } from '../theme-context';
import GlobalComponents, { UI_THEME } from '../../themes/onboarding/figure';

var OnboardingThemeLoader = function OnboardingThemeLoader(_ref) {
  var children = _ref.children,
      useDefaults = _ref.useDefaults;

  var _useTheme = useTheme(),
      setUiTheme = _useTheme.setUiTheme;

  useEffect(function () {
    setUiTheme(UI_THEME);
  }, [setUiTheme]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalComponents, {
    useDefaults: useDefaults
  }), children);
};

var OnboardingThemeContextProvider = function OnboardingThemeContextProvider(_ref2) {
  var children = _ref2.children,
      _ref2$useDefaults = _ref2.useDefaults,
      useDefaults = _ref2$useDefaults === void 0 ? true : _ref2$useDefaults;
  return /*#__PURE__*/React.createElement(ThemeContextProvider, null, /*#__PURE__*/React.createElement(OnboardingThemeLoader, {
    useDefaults: useDefaults
  }, children));
};

export default OnboardingThemeContextProvider;